import { IS_LEGAL_DISCLOSURE_OPENED_CHANGED, INIT_ROOT } from '../actionTypes';

export default (state, { type, payload }) => {
  if (type === INIT_ROOT) {
    return payload.isLegalDisclosureOpened;
  }
  if (type === IS_LEGAL_DISCLOSURE_OPENED_CHANGED) {
    return payload;
  }
  return state || false;
};
